(function(){
  'use strict';
  
  // ============================================
  // CONFIGURACIÓN
  // ============================================
  var CONFIG = {
    // Selector del contenedor de precio
    priceContainer: '.f-product-single__block--price .f-price',
    // Selector del widget de suscripción (el bloque completo)
    subscriptionWidget: '.shopify-app-block:has([id*="joy_subscription_subscription_widget"])',
    // Clase que indica descuento
    discountClass: 'f-price--on-sale',
    // Delay inicial para asegurar que el DOM esté listo
    initDelay: 200,
    // Ocultación temporal (ofertas hasta diciembre): oculta el widget en TODOS
    // los productos, tengan o no descuento, a partir de la fecha indicada.
    // Para desactivarla: enabled: false (vuelve a la regla de solo-descuento).
    forceHide: {
      enabled: true,
      // 29/10 08:00 hora Argentina (UTC-3)
      from: '2026-10-29T08:00:00-03:00'
    }
  };

  // ============================================
  // FUNCIONES AUXILIARES
  // ============================================
  
  /**
   * Espera a que el DOM esté listo
   */
  function domReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  /**
   * Encuentra el widget de suscripción en el DOM
   */
  function findSubscriptionWidget() {
    // Buscar por ID que contenga "joy_subscription_subscription_widget"
    var widgetById = document.querySelector('[id*="joy_subscription_subscription_widget"]');
    if (widgetById) {
      // Retornar el contenedor .shopify-app-block más cercano
      var appBlock = widgetById.closest('.shopify-app-block');
      if (appBlock) {
        return appBlock;
      }
      // Si no encuentra el app-block, retornar el widget directamente
      return widgetById;
    }
    return null;
  }

  /**
   * Extrae el precio numérico de un texto
   */
  function extractPrice(text) {
    if (!text) return null;
    
    // Convertir &nbsp; y otros espacios no separables a espacios normales
    text = text.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
    
    // Eliminar todos los caracteres excepto números, comas y puntos
    var cleaned = text.replace(/[^\d,\.]/g, '').trim();
    
    // Si no hay números, retornar null
    if (!/\d/.test(cleaned)) {
      return null;
    }
    
    // Reemplazar coma por punto (formato español: 22,95 -> 22.95)
    // Solo reemplazar la primera coma para evitar problemas
    cleaned = cleaned.replace(',', '.');
    
    // Si hay múltiples puntos, el último es el decimal
    var parts = cleaned.split('.');
    if (parts.length > 2) {
      // Si hay múltiples puntos, el último es el decimal
      cleaned = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    }
    
    var num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  /**
   * Detecta si el producto tiene descuento
   * Retorna: true = tiene descuento, false = no tiene descuento
   */
  function hasDiscount() {
    try {
      // Buscar el contenedor de precio
      var priceElement = document.querySelector(CONFIG.priceContainer);
      if (!priceElement) {
        // Si no encontramos el precio, asumimos que NO hay descuento (mostrar widget)
        return false;
      }

      // MÉTODO 1: Verificar la clase f-price--on-sale (más confiable y definitivo)
      // Esta clase solo aparece cuando realmente hay un descuento activo
      if (priceElement.classList.contains(CONFIG.discountClass)) {
        return true;
      }

      // MÉTODO 2: Comparar precios numéricamente (el más confiable después de la clase)
      // Comparar precio regular vs precio de venta
      var regularPriceEl = priceElement.querySelector('.f-price__regular .f-price-item--regular');
      var salePriceEl = priceElement.querySelector('.f-price__sale .f-price-item--sale');
      
      if (regularPriceEl && salePriceEl) {
        var regularPrice = extractPrice(regularPriceEl.textContent);
        var salePrice = extractPrice(salePriceEl.textContent);
        
        // Si ambos precios son válidos y el regular es MAYOR que el de venta → HAY descuento
        if (regularPrice !== null && salePrice !== null && regularPrice > salePrice) {
          return true;
        }
      }

      // MÉTODO 3: Comparar precio tachado vs precio de venta
      // Si hay un precio tachado, compararlo con el precio de venta
      var strikethroughPriceEl = priceElement.querySelector('.f-price__sale s.f-price-item--regular');
      if (strikethroughPriceEl && salePriceEl) {
        var strikethroughPrice = extractPrice(strikethroughPriceEl.textContent);
        var salePriceFromStrikethrough = extractPrice(salePriceEl.textContent);
        
        // Si el precio tachado es MAYOR que el precio de venta → HAY descuento
        if (strikethroughPrice !== null && salePriceFromStrikethrough !== null && strikethroughPrice > salePriceFromStrikethrough) {
          return true;
        }
      }

      // Si llegamos aquí, NO hay descuento
      // (No tiene la clase f-price--on-sale Y los precios son iguales o el regular es menor)
      return false;
    } catch (error) {
      // En caso de error, asumimos que NO hay descuento (mostrar widget por seguridad)
      console.warn('Error al detectar descuento:', error);
      return false;
    }
  }

  /**
   * Indica si la ocultación temporal está activa (habilitada y ya pasó la fecha)
   */
  function isForceHideActive() {
    var cfg = CONFIG.forceHide;
    if (!cfg || !cfg.enabled) return false;
    var from = Date.parse(cfg.from);
    return !isNaN(from) && Date.now() >= from;
  }

  /**
   * Decide si el widget debe ocultarse: ocultación temporal O descuento
   */
  function shouldHideWidget() {
    return isForceHideActive() || hasDiscount();
  }

  /**
   * Oculta el widget de suscripción
   */
  function hideWidget(widget) {
    if (!widget) return;
    
    // Aplicar display: none con !important para asegurar que se oculte
    if (widget.style) {
      widget.style.setProperty('display', 'none', 'important');
    }
  }

  /**
   * Muestra el widget de suscripción
   */
  function showWidget(widget) {
    if (!widget) return;
    
    if (widget.style) {
      // Forzar display: block con !important para sobrescribir cualquier estilo previo
      // Esto asegura que el widget se muestre incluso si estaba oculto por otro script
      widget.style.setProperty('display', 'block', 'important');
      
      // Verificar después de un pequeño delay que realmente se muestre
      setTimeout(function() {
        var computed = window.getComputedStyle(widget);
        if (computed.display === 'none') {
          // Si aún está oculto, intentar con otros valores comunes
          widget.style.setProperty('display', 'flex', 'important');
        }
      }, 50);
    }
  }

  /**
   * Evalúa el estado y muestra/oculta el widget según corresponda
   */
  function evaluateAndUpdate() {
    var widget = findSubscriptionWidget();
    
    if (!widget) {
      // Si no encontramos el widget, no hacer nada
      return;
    }

    var hasProductDiscount = shouldHideWidget();

    if (hasProductDiscount) {
      // SI hay descuento (u ocultación temporal) → OCULTAR widget
      hideWidget(widget);
    } else {
      // NO hay descuento → MOSTRAR widget (forzar visibilidad)
      showWidget(widget);
      
      // Verificar después de un pequeño delay que el widget esté visible
      // Si no está visible, intentar mostrarlo de nuevo
      setTimeout(function() {
        var computed = window.getComputedStyle(widget);
        if (computed.display === 'none') {
          // Si aún está oculto después de intentar mostrarlo, forzar de nuevo
          widget.style.setProperty('display', 'block', 'important');
        }
      }, 100);
    }
  }

  /**
   * Debounce para evitar ejecuciones múltiples
   */
  var debounceTimer = null;
  function debouncedEvaluate() {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(evaluateAndUpdate, 100);
  }

  /**
   * Observa cambios en el DOM relacionados con el precio
   */
  function observePriceChanges() {
    var priceContainer = document.querySelector(CONFIG.priceContainer);
    if (!priceContainer) return;

    // Crear observer para detectar cambios en el precio
    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        
        // Verificar si cambió la clase del precio (añadida/removida f-price--on-sale)
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldUpdate = true;
          break;
        }
        
        // Verificar si se añadieron/removieron nodos relacionados con el precio
        if (mutation.type === 'childList') {
          var addedNodes = mutation.addedNodes;
          for (var j = 0; j < addedNodes.length; j++) {
            var node = addedNodes[j];
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('f-price__sale') ||
                node.classList.contains('f-price__regular') ||
                node.querySelector('.f-price-item--regular') ||
                node.querySelector('.f-price-item--sale')
              )) {
                shouldUpdate = true;
                break;
              }
            }
          }
          if (shouldUpdate) break;
        }
      }
      
      if (shouldUpdate) {
        debouncedEvaluate();
      }
    });

    // Observar cambios en el contenedor de precio
    observer.observe(priceContainer, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true,
      characterData: true
    });

    // También observar cambios en el body por si el precio se carga dinámicamente
    var bodyObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Verificar si se añadió el contenedor de precio
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              if (node.matches && node.matches(CONFIG.priceContainer)) {
                debouncedEvaluate();
                // Reiniciar el observer en el nuevo elemento
                observePriceChanges();
                return;
              }
            }
          }
        }
      }
    });

    if (document.body) {
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // ============================================
  // INICIALIZACIÓN
  // ============================================
  
  function init() {
    // Ejecutar evaluación múltiples veces para asegurar que capture el widget
    // incluso si se carga dinámicamente
    var attempts = 0;
    var maxAttempts = 10;
    var attemptInterval = 200;
    
    function tryEvaluate() {
      attempts++;
      evaluateAndUpdate();
      
      // Continuar intentando hasta encontrar el widget o alcanzar el máximo de intentos
      if (attempts < maxAttempts) {
        setTimeout(tryEvaluate, attemptInterval);
      }
    }
    
    // Esperar un poco para asegurar que el DOM esté completamente cargado
    setTimeout(function() {
      // Ejecutar evaluación inicial
      tryEvaluate();
      
      // Iniciar observación de cambios
      observePriceChanges();
      
      // También observar si el widget se carga dinámicamente
      var widgetObserver = new MutationObserver(function() {
        var widget = findSubscriptionWidget();
        if (widget) {
          debouncedEvaluate();
        }
      });

      if (document.body) {
        widgetObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }, CONFIG.initDelay);
  }

  // Iniciar cuando el DOM esté listo
  domReady(init);
  
  // También ejecutar cuando la página esté completamente cargada
  if (document.readyState === 'complete') {
    setTimeout(function() {
      evaluateAndUpdate();
    }, 500);
  } else {
    window.addEventListener('load', function() {
      setTimeout(function() {
        evaluateAndUpdate();
      }, 500);
    });
  }
  
  // Ejecutar periódicamente para asegurar que el estado sea correcto
  // Esto ayuda a capturar cambios dinámicos y sobrescribir otros scripts
  // Solo ejecutar si no hay descuento (para mostrar el widget si está oculto)
  var checkInterval = setInterval(function() {
    var widget = findSubscriptionWidget();
    if (widget) {
      var hasProductDiscount = shouldHideWidget();
      if (!hasProductDiscount) {
        // Si NO hay descuento, asegurarse de que el widget esté visible
        var computed = window.getComputedStyle(widget);
        if (computed.display === 'none') {
          showWidget(widget);
        }
      } else {
        // Si hay descuento, ocultar el widget
        hideWidget(widget);
      }
    }
  }, 2000); // Verificar cada 2 segundos

})();
